
import request from '@/utils/request'
/*
npm菜单管理相关的API请求函数
*/
const api_name = '/portal/web/api'
const login_api_name = '/admin/system/index'

export default {

    // 根据电话号码获取验证码  接口路径 /portal/web/api/member/register/code/{phone}
    registerCode(phone) {
        return request({
            url: `${api_name}/member/register/code/${phone}`,
            method: 'get'
        })
    },
    // member: {phone, code} code需要MD5加密
    // 引入MD5加密处理，对member对象中的code字段进行加密后再提交
    codeLogin(member) {
        const CryptoJS = require("crypto-js");
        const md5Code = CryptoJS.MD5(member.code).toString();
        return request({
            url: `${login_api_name}/login`,
            method: 'post',
            data: {
                phone: member.phone,
                code: md5Code
            }
        });
    },
    //上传图片接口  接口地址/admin/system/index/fileUpload 返回的data就是图片的url地址
    upload(file) {
        return request({
            url: `${login_api_name}/fileUpload`,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: file
        });
    }


}
